// extracted by mini-css-extract-plugin
export default {"wrapper":"eNEIHFnS0TBy9OSqQR0Z"};